import { render } from "./update-level.view.vue?vue&type=template&id=4ac2126f&scoped=true&ts=true"
import script from "./update-level.view.vue?vue&type=script&lang=ts"
export * from "./update-level.view.vue?vue&type=script&lang=ts"

import "./update-level.view.vue?vue&type=style&index=0&id=4ac2126f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac2126f"]])

export default __exports__